import {
  UseMutationOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query"

import { AdminResponses } from "@tfg/types/endpoints/admin"
import {
  standardsCreateValidationType,
  standardsUpdateValidationType,
} from "@tfg/types/schemas/admin"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteStandardMutation = (
  options?: UseMutationOptions<void, unknown, number>
) => {
  return useMutation({
    ...options,
    mutationFn: async (id: number) => {
      const res = await httpClient.delete(`/admin/standards/${id}`)
      return res.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      showSuccessNotification({
        title: "Deleted",
        message: "Successfully deleted standard",
      })
    },
  })
}

export const useCreateStandardMutation = (
  options?: UseMutationOptions<
    standardsCreateValidationType,
    unknown,
    standardsCreateValidationType
  >
) => {
  return useMutation<
    standardsCreateValidationType,
    unknown,
    standardsCreateValidationType
  >({
    ...options,
    mutationFn: async (data: standardsCreateValidationType) => {
      const res = await httpClient.post<standardsCreateValidationType>(
        "/admin/standards",
        { ...data }
      )
      return res.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({ queryKey: ["standards"] })
      showSuccessNotification({
        title: "Added",
        message: "Successfully added standard",
      })
    },
  })
}

export const useUpdateStandardMutation = (
  options?: UseMutationOptions<
    standardsUpdateValidationType,
    unknown,
    standardsUpdateValidationType
  >
) =>
  useMutation<
    standardsUpdateValidationType,
    unknown,
    standardsUpdateValidationType
  >({
    mutationFn: async (standard: standardsUpdateValidationType) => {
      const res = await httpClient.patch<standardsUpdateValidationType>(
        `/admin/standards`,
        standard
      )
      return res.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)

      showSuccessNotification({
        title: "Added",
        message: "Successfully updated certificate Type",
      })
    },
  })

export const useListCertificateTypesQuery = () => {
  return useQuery({
    queryKey: ["certificateTypesList"],

    queryFn: async () => {
      const res = await httpClient.get<AdminResponses.CertificateTypeList[]>(
        "/admin/certificate-types-list"
      )
      return res.data
    },
  })
}
